function _(n,t,o){t.exports=function(){var n=Math.log10;return"function"==typeof n&&.3010299956639812===n(2)}}
//# sourceMappingURL=is-implemented.min.js.map